var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCrystals20X(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 111,
    height: 81,
    viewBox: "0 0 111 81",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3176_8983)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_3176_8983)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M61.6687 18.0613L54.8665 21.5559L46.6673 18.0613C44.0972 10.2926 41.7427 4.05657 45.1444 2.02797C48.5443 0 49.9818 6.49137 49.9818 6.49137C49.9818 6.49137 49.9652 5.63999 50.1475 4.55552C50.471 2.64317 51.4144 0 54.168 0C58.4836 0 58.3523 6.49137 58.3523 6.49137C58.3523 6.49137 59.7917 0 63.1915 2.02797C66.592 4.05657 64.2387 10.2926 61.6687 18.0613Z",
    fill: "#FFD04E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.9736 64.3913C84.9736 47.253 71.1814 26.0514 54.1673 26.0514C37.1538 26.0514 23.3616 47.253 23.3616 64.3913C23.3616 81.5289 37.1538 80.9563 54.1673 80.9563C71.1814 80.9563 84.9736 81.5289 84.9736 64.3913Z",
    fill: "#FFD04E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.3109 80.7993C36.1604 80.816 23.3577 80.7449 23.3577 64.2336C23.3577 47.096 37.1499 25.8938 54.1634 25.8938C45.7831 25.8938 38.9913 47.096 38.9913 64.2336C38.9913 80.0883 44.8053 80.7845 52.3109 80.7993Z",
    fill: "#FD9A07"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.8922 17.9031H46.6626C44.0926 10.1343 41.738 3.89829 45.1398 1.8697C48.5396 -0.158274 49.9772 6.3331 49.9772 6.3331C49.9772 6.3331 50.4547 12.66 51.8922 17.9031Z",
    fill: "#FD9A07"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.0615 21.2307V24.6968C64.0615 26.5349 62.5828 28.0262 60.7586 28.0262H47.5685C45.7437 28.0262 44.2632 26.5349 44.2632 24.6968V21.2307C44.2632 19.3925 45.7437 17.903 47.5685 17.903H60.7586C62.5828 17.903 64.0615 19.3925 64.0615 21.2307Z",
    fill: "#4588B5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.0614 21.2307V24.6968C64.0614 26.5349 62.5827 28.0262 60.7585 28.0262H54.1582C52.3334 28.0262 50.8547 26.5349 50.8547 24.6968V21.2307C50.8547 19.3925 52.3334 17.903 54.1582 17.903H60.7585C62.5827 17.903 64.0614 19.3925 64.0614 21.2307Z",
    fill: "#6B9DC6"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M25.2038 54.1923L25.6245 53.6004C25.575 52.8089 25.2053 52.0826 24.6015 51.5907L12.916 42.0704C12.3122 41.5784 11.5271 41.3639 10.7436 41.4768L10.2868 42.0395L9.13543 49.6361L18.4607 57.2335L25.2038 54.1923Z",
    fill: "#C3DDFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.916 42.0704C12.3122 41.5784 11.5271 41.3639 10.7436 41.4768L10.2868 42.0395L9.70803 45.8581L15.4499 44.1348L12.916 42.0704Z",
    fill: "#A4CCFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.7588 46.8305L9.35768 49.8171L9.40534 50.2942L17.1191 56.5786L17.7566 56.6598L18.7588 46.8305Z",
    fill: "#DBEAFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.7436 41.4768L2.85154 42.613C2.31624 42.6901 1.82456 42.9711 1.47827 43.3977L1.5418 43.8876L8.70594 49.7243L9.35768 49.8171L10.7436 41.4768Z",
    fill: "#DBEAFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.90066 47.0007L10.0316 45.7609L10.7436 41.4768L2.85154 42.613C2.31624 42.6901 1.82456 42.9711 1.47827 43.3977L1.5418 43.8876L5.81894 47.3723L5.90066 47.0007Z",
    fill: "#C3DDFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.6361 63.0792C25.9824 62.6526 26.1566 62.1132 26.1229 61.5724L25.6245 53.6004L17.7566 56.6598L17.8648 57.186L25.2103 63.1704L25.6361 63.0792Z",
    fill: "#DBEAFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.47827 43.3977C1.08962 43.8764 0.878783 44.474 0.883632 45.0831L1.04523 65.1286C1.05227 66.0001 1.43779 66.8128 2.10017 67.3524C2.76261 67.8921 3.63534 68.1046 4.48839 67.9338L24.1102 64.0059C24.7064 63.8865 25.2475 63.5581 25.6361 63.0792L1.47827 43.3977Z",
    fill: "#A4CCFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.90066 47.0007L1.47827 43.3977C1.08962 43.8764 0.878783 44.474 0.883632 45.0831L1.04523 65.1286C1.05004 65.7206 1.22971 66.2851 1.55186 66.7557L5.90066 47.0007Z",
    fill: "#8BB3EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.10017 67.3524C2.31263 67.5255 2.54693 67.6648 2.79512 67.7687L17.7566 56.6598L9.35768 49.8171L1.55186 66.7557C1.70405 66.9779 1.88767 67.1792 2.10017 67.3524Z",
    fill: "#C3DDFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.0004 46.1245L28.4547 45.6453C27.6623 45.6134 26.9019 45.9067 26.3507 46.4569L15.6828 57.105C15.1315 57.6553 14.8377 58.4143 14.8697 59.2052L15.3825 59.7172L22.8212 61.6412L31.3344 53.1437L29.0004 46.1245Z",
    fill: "#C3DDFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.6828 57.105C15.1315 57.6553 14.8377 58.4143 14.8697 59.2052L15.3825 59.7172L19.1218 60.6844L17.9961 54.7962L15.6828 57.105Z",
    fill: "#A4CCFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.0167 51.781L23.024 61.4387L23.5035 61.4402L30.5454 54.4112L30.6916 53.7854L21.0167 51.781Z",
    fill: "#DBEAFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.8697 59.2052L15.191 67.1722C15.2128 67.7125 15.4419 68.2304 15.8307 68.6186L16.3246 68.6056L22.8648 62.0775L23.024 61.4387L14.8697 59.2052Z",
    fill: "#DBEAFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.8681 64.5888L19.0582 60.3525L14.8697 59.2052L15.191 67.1722C15.2128 67.7125 15.4419 68.2304 15.8307 68.6186L16.3246 68.6056L20.2294 64.7082L19.8681 64.5888Z",
    fill: "#C3DDFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.8848 46.6053C37.4959 46.2171 36.9771 45.9885 36.4358 45.9667L28.4547 45.6453L30.6916 53.7854L31.2261 53.7317L37.9319 47.0383L37.8848 46.6053Z",
    fill: "#DBEAFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.8307 68.6186C16.2672 69.0543 16.84 69.3253 17.4463 69.3829L37.4029 71.2768C38.2705 71.3591 39.1184 71.0589 39.7231 70.4553C40.3278 69.8517 40.6286 69.0053 40.5462 68.1392L38.6501 48.2182C38.5925 47.6129 38.3213 47.041 37.8848 46.6053L15.8307 68.6186Z",
    fill: "#A4CCFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.8681 64.5888L15.8307 68.6186C16.2672 69.0543 16.84 69.3253 17.4463 69.3829L37.4029 71.2768C37.9922 71.3326 38.5722 71.2118 39.0733 70.9396L19.8681 64.5888Z",
    fill: "#8BB3EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.7231 70.4553C39.9171 70.2617 40.0796 70.0429 40.2084 69.8067L30.6916 53.7854L23.024 61.4387L39.0733 70.9396C39.3099 70.8109 39.529 70.6489 39.7231 70.4553Z",
    fill: "#C3DDFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.8802 59.3917L98.3165 58.8948C98.3456 58.1732 98.0785 57.4809 97.5775 56.9789L87.8815 47.265C87.3805 46.763 86.6893 46.4954 85.9691 46.5245L85.5029 46.9915L83.7509 53.765L91.4886 61.517L97.8802 59.3917Z",
    fill: "#C3DDFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.8815 47.265C87.3805 46.763 86.6893 46.4954 85.9691 46.5245L85.5029 46.9915L84.6222 50.3964L89.9839 49.3714L87.8815 47.265Z",
    fill: "#A4CCFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.7295 52.1219L83.9353 53.9497L83.934 54.3863L90.3345 60.7986L90.9043 60.9316L92.7295 52.1219Z",
    fill: "#DBEAFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.9691 46.5245L78.7145 46.8171C78.2225 46.837 77.7509 47.0455 77.3974 47.3996L77.4092 47.8493L83.3537 53.8048L83.9353 53.9497L85.9691 46.5245Z",
    fill: "#DBEAFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.0669 51.076L84.9244 50.3385L85.9691 46.5245L78.7145 46.8171C78.2225 46.837 77.7509 47.0455 77.3974 47.3996L77.4092 47.8493L80.9582 51.405L81.0669 51.076Z",
    fill: "#C3DDFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.4424 67.4817C97.7958 67.1276 98.004 66.6552 98.0239 66.1622L98.3165 58.8948L90.9043 60.9316L90.9532 61.4184L97.0481 67.5245L97.4424 67.4817Z",
    fill: "#DBEAFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.3974 47.3996C77.0007 47.797 76.7539 48.3186 76.7015 48.8708L74.977 67.0429C74.902 67.8329 75.1753 68.605 75.725 69.1556C76.2746 69.7062 77.0453 69.9802 77.8339 69.9051L95.9737 68.1786C96.5249 68.1261 97.0456 67.8792 97.4424 67.4817L77.3974 47.3996Z",
    fill: "#A4CCFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.0669 51.076L77.3974 47.3996C77.0007 47.797 76.7539 48.3186 76.7015 48.8708L74.977 67.0429C74.9261 67.5795 75.0361 68.1076 75.284 68.564L81.0669 51.076Z",
    fill: "#8BB3EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.725 69.1556C75.9012 69.3322 76.1005 69.4803 76.3156 69.5975L90.9043 60.9316L83.9353 53.9497L75.284 68.564C75.4011 68.7794 75.5486 68.9789 75.725 69.1556Z",
    fill: "#C3DDFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.646 63.0642L107.914 62.759C107.932 62.3158 107.768 61.8906 107.46 61.5823L101.505 55.6157C101.197 55.3074 100.772 55.143 100.33 55.1609L100.044 55.4478L98.9675 59.6082L103.72 64.3696L107.646 63.0642Z",
    fill: "#C3DDFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.505 55.6157C101.197 55.3074 100.772 55.143 100.33 55.1609L100.044 55.4478L99.5027 57.5391L102.796 56.9095L101.505 55.6157Z",
    fill: "#A4CCFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.482 58.599L99.0808 59.7217L99.0799 59.9898L103.011 63.9284L103.361 64.0101L104.482 58.599Z",
    fill: "#DBEAFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.33 55.1609L95.874 55.3407C95.5718 55.3529 95.2822 55.481 95.065 55.6985L95.0723 55.9747L98.7235 59.6326L99.0808 59.7217L100.33 55.1609Z",
    fill: "#DBEAFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.3189 57.9566L99.6883 57.5036L100.33 55.1609L95.874 55.3407C95.5718 55.3529 95.2822 55.481 95.065 55.6985L95.0723 55.9747L97.2521 58.1586L97.3189 57.9566Z",
    fill: "#C3DDFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.377 68.0333C107.594 67.8158 107.722 67.5256 107.734 67.2229L107.914 62.759L103.361 64.0101L103.391 64.3091L107.135 68.0596L107.377 68.0333Z",
    fill: "#DBEAFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.065 55.6985C94.8214 55.9425 94.6698 56.2629 94.6376 56.6021L93.5783 67.7638C93.5323 68.249 93.7002 68.7233 94.0378 69.0614C94.3754 69.3997 94.8488 69.5679 95.3331 69.5218L106.475 68.4613C106.814 68.4291 107.133 68.2774 107.377 68.0333L95.065 55.6985Z",
    fill: "#A4CCFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.3189 57.9566L95.065 55.6985C94.8214 55.9425 94.6698 56.2629 94.6376 56.6021L93.5783 67.7638C93.5471 68.0934 93.6147 68.4177 93.7669 68.6981L97.3189 57.9566Z",
    fill: "#8BB3EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.0378 69.0614C94.1461 69.1699 94.2684 69.2609 94.4006 69.3329L103.361 64.0101L99.0808 59.7217L93.7669 68.6981C93.8389 68.8304 93.9295 68.9529 94.0378 69.0614Z",
    fill: "#C3DDFF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3176_8983"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 111,
    height: 81,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_3176_8983"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 65,
    fill: "white",
    transform: "translate(21)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCrystals20X);
export default __webpack_public_path__ + "static/media/crystals20x.5c1431d5c2fe26e166075297b2314807.svg";
export { ForwardRef as ReactComponent };